<template>
  <zm-row :span="24" class="comparison-tree-table-mobile__plan-row">
    <zm-row class="comparison-tree-table-mobile__feature-row">
      <zm-col :span="24">
        <div class="comparison-tree-table-mobile__feature-title-wrapper">
          <span
            tabindex="-1"
            class="comparison-tree-table-mobile__feature-content"
            :class="[
              'comparison-tree-table-mobile__sub-text',
              row.isNew ? 'comparison-tree-table-mobile__new-content' : '',
              row.footerDesc ? 'comparison-tree-table-mobile__sub-text__footer' : '',
            ]"
            :data-label="row.isNew ? t('marketing.one.new') : ''"
          >
            <span v-if="row.icon" class="table-feature-icon-mobile" :class="'icon-' + panel.icon"></span>
            <template v-if='Array.isArray(row.feature)'>
              <div v-for='(item,index) in row.feature' :key='index'>
                <span v-html="item"></span>
              </div>
            </template>
            <span v-else v-html="row.feature"></span>
            <zm-tooltip placement="top">
              <div slot="content" v-html="row.tooltip"></div>
              <button
                data-testid="common-button-31"
                class="comparison-tree-table-mobile__button-icon"
                v-if="row.tooltip"
                :aria-label="row.feature"
                @mousedown="mouseInToolTip(row)"
              >
                <span class="sr-only">{{ t('marketing.helpTooltipIcon') }}</span>
                <i class="zm-icon-info-outline"></i>
              </button>
            </zm-tooltip>
          </span>
          <a
            v-if="row.pdf"
            data-testid="common-a-32"
            tabindex="-1"
            href="https://explore.zoom.us/docs/doc/Phone-NomadicE911-6-2020.pdf"
            target="_blank"
          >
            {{ t('marketing.phone.fullPlanItem20Pdf') }}
          </a>
          <div v-if="row.link">
            <a
              v-if="row.link.callback"
              data-testid="common-a-33"
              :class="row.link.classname || ''"
              :style="row.link.style || {}"
              tabindex="-1"
              href="javascript:void(0);"
              @click="row.link.callback"
              :aria-label="row.link.ariaLabel || row.link.text"
            >
              {{ row.link.text }}
            </a>
          </div>
        </div>
      </zm-col>
    </zm-row>
    <zm-row class="comparison-tree-table-mobile__body-row" v-if='!row.footerDesc'>
      <template v-for="(col, colIdx) in selectedValues">
        <zm-col :key="col" :span="colSpan" :style="colIdx === 0 ? 'padding-right: 4px' : 'padding-left: 4px'">
          <template v-if="row.isString">
            <span v-if="row[col] && row[col] !== true" tabindex="-1" v-html="row[col]"></span>
            <i v-else-if="row[col] === true" tabindex="-1" class="zm-icon-ok" :aria-label="t('marketing.included')"></i>
            <i v-else tabindex="-1" class="zm-icon-minus" :aria-label="t('marketing.notIncluded')"></i>
            <div v-if="col === 'enterprise' && row.enterpriseDesc" tabindex="-1" class="cell-desc">
              *{{ row.enterpriseDesc }}
            </div>
          </template>
          <template v-else>
            <i v-if="row[col] === true" tabindex="-1" class="zm-icon-ok" :aria-label="t('marketing.included')"></i>
            <span v-else-if="row[col] && row.mixed && typeof row[col] === 'string'" tabindex="-1" v-html="row[col]"></span>
            <i v-else tabindex="-1" class="zm-icon-minus" :aria-label="t('marketing.notIncluded')"></i>
            <template v-if="row.desc">
              <div v-if="typeof row.desc === 'string'" tabindex="-1" class="cell-desc" v-html="row.desc"></div>
              <div v-if="typeof row.desc === 'object'" tabindex="-1" class="cell-desc" v-html="row.desc[col]"></div>
            </template>
            <div
              v-if="row.multiDesc && row[`desc${getColConfigIdx(col) + 1}`]"
              tabindex="-1"
              class="cell-desc"
              v-html="row[`desc${getColConfigIdx(col) + 1}`]"
            ></div>
            <div v-if="col === 'enterprise' && row.enterpriseDesc" tabindex="-1" class="cell-desc">
              <span class="cell-desc">{{ row.enterpriseDesc }}</span>
            </div>
          </template>
        </zm-col>
      </template>
    </zm-row>
  </zm-row>
</template>

<script>
import { t } from '@/plugins/i18n';

export default {
  props: {
    row: {
      type: Object,
      default: () => ({}),
    },
    selectedValues: Array,
    getColConfigIdx: Function,
    colSpan: Number,
  },

  methods: {
    t,
    mouseInToolTip(row) {
      window.dataLayer.push({
        event: 'pricingInteraction',
        pricingInteraction: 'tool tip',
        pricingSelection: `${row.feature}`,
        uiLocation: 'features',
      });
    },
  },
};
</script>

<style lang="scss">
.comparison-tree-table-mobile {
  &__sub-text__footer {
    color: #666487;
    font-size: 12px;
    line-height: 18px;
    font-weight: normal;
  }
  &__plan-row {
    padding: 0 8px;
    &:nth-child(even) {
      background: #f7f7f8;
    }
  }

  &__feature-row {
    padding: 12px 0;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.2;
    color: #00053d;
  }

  &__button-icon {
    margin-left: 4px;
    display: inline-block;
    background: transparent;
    border: 0;
  }

  &__body-row {
    display: flex;
    align-items: center;
    padding: 12px 0;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.5;
    text-align: center;
    color: #00053d;
  }

  &__new-content::after {
    position: relative;
    top: -1px;
    margin-left: 4px;
    padding: 2px 4px;
    content: attr(data-label);
    font-size: 12px;
    font-weight: 900;
    color: #0e72ed;
    background-color: #f2f2f4;
    border-radius: 4px;
    text-transform: uppercase;
  }

  .cell-desc {
    display: block;
    font-size: 12px;
    line-height: 1;
    text-align: center;
    color: #666487;
  }

  .zm-icon-info-outline {
    font-size: 14px;
    color: #4f90ee;
    vertical-align: middle !important;
  }
  .zm-icon-ok {
    font-size: 16px;
    font-weight: 700;
    color: #0e72ed;
  }
  .zm-icon-minus {
    font-size: 16px;
    color: rgba(4, 4, 19, 0.56);
    opacity: 0.6;
  }

  .table-feature-icon-mobile {
    display: inline-block;
    margin-top: 3px;
    margin-right: 3px;
    width: 16px;
    height: 16px;
    background-size: contain;
    &.icon-sessions {
      background: url('~@/assets/developer/sessions.svg') no-repeat;
    }
    &.icon-minutes {
      background: url('~@/assets/developer/minutes.svg') no-repeat;
    }
    &.icon-storage {
      background: url('~@/assets/developer/storage.svg') no-repeat;
    }
    &.icon-audio {
      background: url('~@/assets/developer/audio.svg') no-repeat;
    }
    &.icon-connector {
      background: url('~@/assets/developer/connector.svg') no-repeat;
    }
    &.icon-transcription {
      background: url('~@/assets/developer/transcription.svg') no-repeat;
    }
    &.icon-subscription {
      background: url('~@/assets/developer/subscription.svg') no-repeat;
    }
  }
}
</style>
